<div id="drug-page-grid-controls">
  <div class="drug-page-grid-controls-dropdown">
    <span class="grid-control">
      <va-period-filter
        [periodData]="defaultPeriodObj"
        [filterWidthVariation]="3"
        [periodMinMax]="periodMinMax"
        (onApply)="periodSettingsChange($event)"
      ></va-period-filter>
    </span>
    <div class="grid-control currency-filter" style="width: 78px">
      <va-currency-select
        size="small"
        selectWidth="78"
        labelPlacement="top"
        [bottomBorderView]="true"
        [selectedCurrency]="selectedCurrency"
        [disabled]="currencyDisabled"
        [apiEP]="apiEP"
        apiUrl="/api/get_available_currencies"
        (onChange)="onCurrencyChange($event)"
      >
      </va-currency-select>
    </div>
    <div class="grid-control">
      <app-drug-distribution-data-revision-dropdown
        singleSelect="true"
        [dataView]="dataView"
        (saveDataView)="updateDataView($event)"
      >
      </app-drug-distribution-data-revision-dropdown>
      <!-- <app-data-revisions-dropdown
        singleSelect="true"
        [dataView]="dataView"
        (saveDataView)="updateDataView($event)"
      ></app-data-revisions-dropdown> -->
    </div>
  </div>
  <div class="grid-control-reset-button">
    <va-button btnType="outline" size="small" (click)="handleOnReset()"
      >Reset</va-button
    >
  </div>
</div>
